import { render, staticRenderFns } from "./ViewerComponent.vue?vue&type=template&id=55234c4b&scoped=true&"
import script from "./ViewerComponent.vue?vue&type=script&lang=js&"
export * from "./ViewerComponent.vue?vue&type=script&lang=js&"
import style0 from "./ViewerComponent.vue?vue&type=style&index=0&id=55234c4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55234c4b",
  null
  
)

export default component.exports